import React, { useMemo } from "react";
import { connect } from "dvajs";
import { ListItemData, ListItemProps } from "@jd/focus-desktop-comps/lib/es/ListItem";
import {
  RecommendedType,
  StatusLabels,
  StatusLabelsText,
  StatusLabelsStyles,
  RecommendedTypeTitle
} from "@/services/AppStore";
import Rate from "@/components/ThirdApp/components/Rate";
import { tagsNode, tagsNodeSimple } from "@/components/AddressBook/common";
import "./SearchAppItem.less";
import { UserState } from "@/models/user";
import { changeEgovUrl } from "@/utils/tools";
import { FocusSDK } from "@/utils";
import { retryBtnAll } from "@/components/Joyspace/components/BatchDownloadPanel/config/btn.config";

const SearchAppItem = (
  props: {
    data: ListItemData;
    onClick?: (data: ListItemData) => void;
    t: any;
    userInfo: any;
  } & ListItemProps
) => {
  const { data, onClick, t, userInfo, ...rest } = props;
  const appInfo = data.origin.ext;
  const lables = []
    .concat(appInfo?.networkEnvLabels || [])
    .concat(appInfo?.applicationStatusLabels || []);

  const curTeamTags = useMemo(() => {
    if (appInfo?.teamTags) {
      return appInfo.teamTags.filter((itm: any) => itm.teamId === userInfo?.teamId);
    } else {
      return [];
    }
  }, [appInfo.teamTags, userInfo.teamId]);
  const getCornerMarkOptions = () => {
    const arr = [];
    if ((appInfo?.applicationStatusLabels || []).includes(StatusLabels.UNDER_MAINTENANCE)) {
      arr.push({
        text: StatusLabelsText[StatusLabels.UNDER_MAINTENANCE],
        styles: StatusLabelsStyles[StatusLabels.UNDER_MAINTENANCE]
      });
    }
    if (appInfo?.recommended === RecommendedType.RecommendedYes) {
      arr.push({
        text: RecommendedTypeTitle[RecommendedType.RecommendedYes],
        styles: StatusLabelsStyles.default
      });
    }
    if ((appInfo?.applicationStatusLabels || []).includes(StatusLabels.BETA)) {
      arr.push({
        text: StatusLabelsText[StatusLabels.BETA],
        styles: StatusLabelsStyles[StatusLabels.BETA]
      });
    }
    return arr;
  };
  const robotTag = useMemo(() => {
    if (data?.origin?.ext?.isBot) {
      return tagsNodeSimple({
        name: "机器人",
        color: "BD3AC2"
      });
    } else {
      return null;
    }
  }, [data]);

  const cornerMarkOptions: any = getCornerMarkOptions();
  return (
    <div
      className="search-app-item"
      style={{ alignItems: "flex-start" }}
      onClick={() => {
        if (onClick) {
          try {
            FocusSDK.printLog("open thirdappliction from search", JSON.stringify(data));
          } catch (e) {}

          onClick(data);
        }
      }}
    >
      <img className="search-app-item_img" src={changeEgovUrl(data.origin.avatar)} />
      <div className="search-app-item_right">
        <div className="search-app-item_right_info">
          <div className="search-app-item_title color-primary">{data.name}</div>
          {/* {
            data.origin &&
            data.origin.ext &&
            data.origin.ext.recommended === RecommendedType.RecommendedYes && <Rate value={0} />
          } */}
          {robotTag}
          {data.origin && data.origin.labelInfoList && tagsNode(data.origin.labelInfoList)}
        </div>
        <div>
          <span className="third-content-item_lable">
            {(curTeamTags || []).map((item: any) => {
              return <span key={item.tagId}>{item.name}</span>;
            })}
            {lables
              .concat(data.origin.ext?.applicationStatusLabels || [])
              .map((key: any, index: any) => {
                const text = StatusLabelsText[key];
                if (
                  cornerMarkOptions.find((item: any) => item.text === text) ||
                  text === StatusLabelsText[StatusLabels.VPN]
                ) {
                  return "";
                }
                return <span key={"net" + index}>{text}</span>;
              })}
          </span>
        </div>
        <p className="search-app-item_text">{data.brief}</p>
        {data.developer && (
          <p className="search-app-item_text highlight">
            开发者：<div className="highlight-wrap">{data.developer || ""}</div>
          </p>
        )}
        {data.builder && (
          <p className="search-app-item_text highlight">
            建设方：<div className="highlight-wrap">{data.builder || ""}</div>
          </p>
        )}
      </div>
    </div>
  );
};

function mapStateToProps({ user }: { user: UserState }) {
  const userData = user.userData.user;
  return {
    userInfo: {
      app: userData.ddAppId,
      userId: userData.userId,
      teamId: userData.teamUserInfo.teamId
    }
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchAppItem);
